import { Box, Button, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import { useModuleAvailability } from 'modules/core/hooks/useModuleAvailability'
import i18n from 'modules/core/lib/i18n'

import { WorkAreaNode } from 'modules/locations/hooks/useWorkAreas'

import Options from './Options'

interface PropsWorkArea {
  locationId: string
  workArea: NonNullable<WorkAreaNode>
  workSpacesCount: number
  workAreaMapUrl?: string
  canManageWorkArea: boolean
  canAddSpace: boolean
}

const WorkAreaItem = ({
  locationId,
  workArea,
  workSpacesCount,
  workAreaMapUrl,
  canManageWorkArea,
  canAddSpace,
}: PropsWorkArea) => {
  const { moduleAvailability } = useModuleAvailability(AvailableModules.space_control)
  const spacesEnabled = moduleAvailability.available
  const disableArchiveButton = workSpacesCount > 0
  const [isMapTooltipOpen, toggleMapTooltip] = useToggle(false)
  const canManageSpaces = spacesEnabled && canAddSpace

  const WorkAreaData = () => (
    <>
      <Box gap="s12" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <>
          <Text.Normal size="300" weight="medium" color="grey1000">
            {workArea.name}
          </Text.Normal>
          {spacesEnabled && (
            <Text.Normal size="200" weight="normal" color="grey800">
              {i18n.tp('settings.locations.location.work_areas.spaces_count', {
                count: workSpacesCount,
              })}
            </Text.Normal>
          )}
        </>
        <Box flexDirection="row" gap="s8">
          <Box onMouseEnter={toggleMapTooltip(true)} onMouseLeave={toggleMapTooltip(false)}>
            <Tooltip.Alt
              attachment="top center"
              open={isMapTooltipOpen}
              label={
                workAreaMapUrl
                  ? i18n.t('settings.locations.location.work_areas.map.has_map')
                  : i18n.t('settings.locations.location.work_areas.map.no_map')
              }
            >
              <Button
                type="secondary"
                disabled={!workAreaMapUrl}
                onClick={() => workAreaMapUrl && window.open(workAreaMapUrl, '_blank')}
                iconName="pin"
              />
            </Tooltip.Alt>
          </Box>
          {canManageWorkArea && (
            <Options
              workArea={workArea}
              locationId={locationId}
              disableArchiveButton={disableArchiveButton}
              canManageSpaces={canManageSpaces}
            />
          )}
        </Box>
      </Box>
    </>
  )

  return (
    <Box
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Box
        paddingX="s24"
        paddingY="s16"
        borderRadius={{ topLeft: 'abs008', topRight: 'abs008' }}
        {...(workSpacesCount > 0
          ? {
              border: {
                bottom: {
                  color: 'grey400',
                  width: 's1',
                  style: 'solid',
                },
              },
            }
          : {})}
        {...(spacesEnabled ? { background: 'grey200' } : {})}
      >
        <WorkAreaData />
      </Box>
    </Box>
  )
}

export default observer(WorkAreaItem)
